module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "codice-fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "onboarding-backdrop",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": 'onboarding-title'
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return; }
        _vm.dismiss($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "codice-rise",
      "appear": ""
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "onboarding-modal",
    attrs: {
      "role": "document"
    }
  }, [_c('span', {
    staticClass: "corner corner-tl",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 16 16",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 15 V8 H4 V5 H7 V2 H15",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "square",
      "stroke-linejoin": "miter"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "corner corner-tr",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 16 16",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 15 V8 H12 V5 H9 V2 H1",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "square",
      "stroke-linejoin": "miter"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "corner corner-bl",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 16 16",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 1 V8 H4 V11 H7 V14 H15",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "square",
      "stroke-linejoin": "miter"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "corner corner-br",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 16 16",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 1 V8 H12 V11 H9 V14 H1",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "square",
      "stroke-linejoin": "miter"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "lang-toggle",
    attrs: {
      "role": "group",
      "aria-label": "Language"
    }
  }, [_c('button', {
    staticClass: "lang-btn",
    class: {
      active: _vm.lang === 'es'
    },
    attrs: {
      "type": "button",
      "aria-label": "Español"
    },
    on: {
      "click": function($event) {
        _vm.setLang('es')
      }
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('span', {
    staticClass: "lang-sep",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('button', {
    staticClass: "lang-btn",
    class: {
      active: _vm.lang === 'en'
    },
    attrs: {
      "type": "button",
      "aria-label": "English"
    },
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _c('button', {
    staticClass: "close-btn",
    attrs: {
      "type": "button",
      "aria-label": _vm.t.closeAria
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 20 20",
      "width": "20",
      "height": "20",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4 L16 16 M16 4 L4 16",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.4",
      "stroke-linecap": "round"
    }
  })])])]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "onboarding-title"
    }
  }, [_vm._v(_vm._s(_vm.t.title))]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 12",
      "width": "120",
      "height": "12"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 6 H38 M44 6 L52 2 L60 6 L52 10 Z M66 6 H102",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "miter"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "40",
      "cy": "6",
      "r": "1.3",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "64",
      "cy": "6",
      "r": "1.3",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52 3.5 L57.5 6 L52 8.5 L46.5 6 Z",
      "fill": "currentColor",
      "opacity": "0.35"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "lede"
  }, [_vm._v(_vm._s(_vm.t.intro1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.intro2))]), _vm._v(" "), _c('h3', {
    staticClass: "rubric"
  }, [_vm._v(_vm._s(_vm.t.howToReadTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.howToRead1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.howToRead2))]), _vm._v(" "), _c('h3', {
    staticClass: "rubric"
  }, [_vm._v(_vm._s(_vm.t.howToInteractTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t.howToInteract))])]), _vm._v(" "), _c('div', {
    staticClass: "cta-wrap"
  }, [_c('button', {
    staticClass: "start-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v("\n            " + _vm._s(_vm.t.cta) + "\n          ")])])]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bec0e42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnboardingModal.vue
// module id = 62
// module chunks = 2